<template>
  <Form
    :key="viewKey"
    :data="reauthForm"
    :fieldValues="fieldValues"
    :formErrorMsg="reauthFailedMsg"
    @form-validated="doReauth($event)"
  >
    <template v-slot:topText>
      <p class="pap-form__text">
        For security purposes, before you can
        {{ actionStatement }}, we need to verify your account credentials.
        Please enter and submit your <strong>current</strong> email and
        password.
        <slot></slot>
      </p>
    </template>
  </Form>
</template>

<script>
import Form from '@/components/form/Form';

import { Login } from '@/models/Login';

export default {
  name: 'FormReauth',
  props: ['formTitle', 'actionStatement'],
  components: {
    Form,
  },
  data: function () {
    return {
      reauthForm: this.reauthFormData(),

      fieldValues: null,
      errorMsg: '',
      viewKeyStore: 1,
    };
  },
  computed: {
    reauthFailedMsg: function () {
      return this.errorMsg;
    },
    viewKey: function () {
      return this.viewKeyStore;
    },
  },
  methods: {
    // Create and return the 'reauthentication' form data obj for the corresponding Form component
    reauthFormData: function () {
      var formData = {
        //formTitle: 'ID Check Before Changing Email...',
        formTitle: this.formTitle,
        actionStatement: this.actionStatement, // 'change your email address' or 'delete your account' -- used in form top text
        headerIconClass: 'fas fa-id-card mr-2',
        orderedFields: ['email', 'password'],
        submitButtonText: 'Submit',
        model: Login,
        fields: {
          email: {
            type: 'text',
            label: 'Current Email',
            placeholder: 'Current email address',
            maxLength: Login.getPropTruncateLength('email'),
            value: '',
            valid: null,
            errorMsg: '',
          },
          password: {
            type: 'password',
            label: 'Current Password',
            placeholder: 'Current password',
            maxLength: Login.getPropTruncateLength('password'),
            value: '',
            valid: null,
            errorMsg: '',
          },
        },
      };
      return formData;
    },
    doReauth: async function (isValidFormData) {
      console.log('doReauth', isValidFormData);
      if (isValidFormData) {
        try {
          await this.$fapi.reauthEmPw(
            isValidFormData.email,
            isValidFormData.password
          );
          this.errorMsg = '';
          // throw Error('Reauthorization failed!');
          this.$emit('reauth-validated', true);
        } catch (err) {
          console.error(err);

          // Since need to now pass in the form fields data (email and pw) BACK to the Form component (via the fieldValues prop),
          // explicitly set password to '' because even WITH its actual value left intact, it will not show the re-displayed form,
          // and clicking the form's Submit button to re-validate will pass validation; want to NOT pass validation so that user
          // can SEE that - as expected - an empty password input element should show error state (with field rule text, i.e. "must be
          // filled in" or whatever) AND show the form error message at the bottom, i.e. "Please correct errors shown above, etc..."
          isValidFormData.password = '';
          this.fieldValues = isValidFormData;

          // Catch and re-word reauth errors.
          // Here are the error messages thrown for each of these conditions:
          // 1) User enters non-current email with either correct/incorrect pw: The supplied credentials do not correspond to the previously signed in user.
          // 2) User enters current email with incorrect pw: The password is invalid or the user does not have a password.
          // this.errorMsg = err.message;
          this.errorMsg =
            'Failed to verify your credentials. Be sure to enter both your current email and password correctly.';
          this.rerenderView();
          // this.resultType = 'error';
          // this.resultErrorMsg =
          //   'Verification of credentials failed: Invalid email/password combination. Please re-enter one or both and try again.';
          // err.message
        }
      } else {
        this.errorMsg = '';
      }
    },
    rerenderView: function () {
      this.viewKeyStore += 1;
    },
  },
};
</script>

<style>
</style>